import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { reduxActions, RootState } from '../../../store';

import { withRouter, RouteComponentProps } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import arxeiaWhiteLogo from '../../../assets/images/logo-arxeia-white.png';
import { myTheme } from '../../../assets/styles/my-theme';
import { CommandBar, FocusZone, FocusZoneDirection, getFocusStyle, getTheme, Icon, IPanelStyles, IPersonaSharedProps, IPersonaStyles, ITheme, Label, List, mergeStyleSets, Panel, PanelType, Persona, PersonaPresence, PersonaSize, SearchBox, Separator } from '@fluentui/react';
import { IAoo } from '../../../shared/interfaces';
import { store } from '../../..';
import aoosService from '../../../services/aoos.service';




const theme: ITheme = getTheme();
const { semanticColors, fonts } = theme;
const { palette } = myTheme;
const classNames = mergeStyleSets({
    itemCell: [
        getFocusStyle(theme, { inset: -1 }),
        {
            padding: 10,
            cursor: 'pointer',
            boxSizing: 'border-box',
            borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: 'flex',
            selectors: {
                '&:hover': { background: palette.neutralLight },
            },
        },
    ],
    itemImage: {
        flexShrink: 0,
    },
    itemContent: {
        marginLeft: 10,
        overflow: 'hidden',
        flexGrow: 1,
    },
    itemName: [
        fonts.mediumPlus,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    ],
    itemIndex: {
        fontSize: fonts.small.fontSize,
        color: palette.neutralTertiary,
        marginBottom: 10,
    },
    chevron: {
        alignSelf: 'center',
        marginLeft: 10,
        color: palette.neutralTertiary,
        fontSize: fonts.large.fontSize,
        flexShrink: 0,
    },
});
const personaStyles: Partial<IPersonaStyles> = {
    root: {
        flexFlow: 'row-reverse',
        color: '#fff',
        '& .ms-Persona-initials': {
            backgroundColor: 'transparent !important',
            border: '1px solid',
        }

    },
    details: { textAlign: 'right' },
    primaryText: { color: '#fff', ':hover': { color: '#fff' } },
    secondaryText: { color: '#fff' },

};

const panelStyles: Partial<IPanelStyles> = {
    scrollableContent: {

    }
};
export interface TopbarMenuProps {
}

type Props = TopbarMenuProps & RouteComponentProps


const TopbarMenu: React.FunctionComponent<Props> = props => {

    const selectArxeiaConfigurations = (state: RootState) => state.sessionReducer.arxeiaConfigurations;
    const arxeiaConfigurations = useSelector(selectArxeiaConfigurations);
    const selectCurrentUser = (state: RootState) => state.sessionReducer.currentUser;
    const currentUser = useSelector(selectCurrentUser);
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);
    const selectUserActiveAoo = (state: RootState) => state.sessionReducer.userActiveAoo;
    const userActiveAoo = useSelector(selectUserActiveAoo);
    const selectSidebarMenuIsOpen = (state: RootState) => state.sessionReducer.sidebarMenuIsOpen;
    const sidebarMenuIsOpen = useSelector(selectSidebarMenuIsOpen);
    const selectAooMenuIsOpen = (state: RootState) => state.sessionReducer.aooMenuIsOpen;
    const aooMenuIsOpen = useSelector(selectAooMenuIsOpen);
    const [aooItems, setAooItems] = useState<IAoo[]>([]);
    const [filteredAooItems, setFilteredAooItems] = useState<IAoo[]>([]);
    const [showBrand, setShowBrand] = useState<boolean>(false);


    useEffect(() => {
        ////////////// Aggiorno le AOO dell'utente
        aoosService.getActiveAooForCurrentUser()
            .then(userActiveAoo => {
                store.dispatch(reduxActions.sessionActions.updateSession({ userActiveAoo: userActiveAoo }))

            })
        //////////////

    }, []) /// si comporta come componentDidMount

    useEffect(() => {
        if (currentAoo && userActiveAoo) {
            let userActiveAooNoCurrent: IAoo[] = userActiveAoo.filter(el => el.id != currentAoo?.id);
            setAooItems(userActiveAooNoCurrent);
            setFilteredAooItems(userActiveAooNoCurrent);
        }

    }, [currentAoo, userActiveAoo])

    useEffect(() => {
        if (arxeiaConfigurations) {
            let configurationIndex = arxeiaConfigurations.findIndex(el => el.key === "ShowBrand");
            if (configurationIndex >= 0) {
                let showBrandConfiguration = arxeiaConfigurations[configurationIndex];
                let showBrandValue = showBrandConfiguration.value.toLowerCase() === "true";
                setShowBrand(showBrandValue);
            }
        }

    }, [arxeiaConfigurations])


    const openPanel = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        ev.preventDefault();
        store.dispatch(reduxActions.sessionActions.updateSession({ aooMenuIsOpen: true }))

    }
    const dismissPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        store.dispatch(reduxActions.sessionActions.updateSession({ aooMenuIsOpen: false }))
    }

    const onAooFilterChanged = (_: any, text: string | undefined): void => {
        if (text != undefined) {
            let newAooItems = [...aooItems];
            setFilteredAooItems(newAooItems.filter(item => item.name.toLowerCase().indexOf(text.toLowerCase()) >= 0));
        }
        else {
            setFilteredAooItems([...aooItems]);
        }
    };

    const onAooToggleClick = (ev?: React.MouseEvent<HTMLElement>, item?: IAoo): void => {
        ev?.preventDefault();
        store.dispatch(reduxActions.sessionActions.updateSession({ aooMenuIsOpen: false }))

        //    let redirectUrl = `${window.location.origin}/#/${item?.id}`;
        //    window.location.href = redirectUrl;
        props.history.push({ pathname: `/${item?.id}/ricerca` });
        props.history.go(0);//forza il refresh
    }

    const onRenderAooCell = (item: IAoo | undefined, index: number | undefined): JSX.Element => {
        return (
            <div className={classNames.itemCell} data-is-focusable={true} onClick={(ev) => onAooToggleClick(ev, item)}>
                <div className={classNames.itemContent}>
                    <div className={classNames.itemName}>
                        {item?.name}
                    </div>
                </div>
            </div>
        );
    };

    const onSidebarMenuToggleClickHandler = (): void => {
        let showSidebar = sidebarMenuIsOpen;
        store.dispatch(reduxActions.sessionActions.updateSession({ sidebarMenuIsOpen: !showSidebar }))

    }



    const persona: IPersonaSharedProps = currentUser ? {
        imageUrl: currentUser.imageUrl,
        imageInitials: currentUser.initials,
        text: currentUser.displayName,
        presence: currentUser.presence ? currentUser.presence : PersonaPresence.none,
        secondaryText: currentAoo?.name,
        showSecondaryText: true,
        hidePersonaDetails: false
    } : {};



    return (

        <div className="topbar">
            <div className="topbar-main">
                <span id="menu-button" onClick={onSidebarMenuToggleClickHandler} >
                    <FontAwesomeIcon icon={['fal', 'bars']} />
                </span>
                {showBrand &&
                    <a className="app-logo">
                        <img alt="main logo" src={arxeiaWhiteLogo} className="logo" />
                    </a>
                }
                <div className="app-name">Protocollo</div>              


       
                {currentUser && (
                    <a className="persona-details" onClick={openPanel}>

                        <Persona
                            {...persona}
                            size={PersonaSize.size32}
                            styles={personaStyles}
                        />
                    </a>
                )}

            </div >
            <Panel
                isLightDismiss
                isOpen={aooMenuIsOpen}
                onDismiss={dismissPanel}
                type={PanelType.custom}
                customWidth={'400px'}
                closeButtonAriaLabel="Close"
                isHiddenOnDismiss={false}
                className='topbar-panel'

            >
                <div className='topbar-panel-content'>
                    <Persona
                        {...persona}
                        size={PersonaSize.size56}
                    />
                    <Separator />
                    {aooItems.length > 0 &&
                        <div className='topbar-panel-aoolist'>
                            {aooItems.length >= 6 &&
                                <SearchBox placeholder="AOO" onChange={onAooFilterChanged} />
                            }
                            <div className={`position-relative my-scroll-div`}>
                                <List items={filteredAooItems} onRenderCell={onRenderAooCell} style={{ marginBottom: 30 }} />
                            </div>
                        </div>}

                </div>
            </Panel>
        </div >

    );
}

export default withRouter(TopbarMenu);



